import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "alert alert-success d-flex align-items-center" }
const _hoisted_2 = { class: "list-group" }
const _hoisted_3 = { class: "flex-grow-1 min-width-0" }
const _hoisted_4 = { class: "fw-semibold" }
const _hoisted_5 = { class: "small text-muted" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "d-flex align-items-start justify-content-between gap-3 mb-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_10 = {
  key: 1,
  class: "text-muted py-3"
}
const _hoisted_11 = { class: "text-muted text-uppercase small fw-semibold mt-3 mb-2" }
const _hoisted_12 = { class: "list-group" }
const _hoisted_13 = { class: "found-values-label flex-shrink-0" }
const _hoisted_14 = { class: "fw-semibold" }
const _hoisted_15 = { class: "small text-muted" }
const _hoisted_16 = { class: "flex-grow-1 min-width-0" }
const _hoisted_17 = ["id", "checked", "onChange"]
const _hoisted_18 = ["for"]
const _hoisted_19 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_20 = ["aria-expanded", "onClick"]
const _hoisted_21 = { class: "small text-muted" }
const _hoisted_22 = ["value", "onChange"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["value", "onInput"]
const _hoisted_26 = {
  key: 1,
  class: "small text-muted"
}
const _hoisted_27 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_28 = ["id", "checked", "disabled", "onChange"]
const _hoisted_29 = ["for"]
const _hoisted_30 = {
  key: 1,
  class: "small text-warning-emphasis"
}
const _hoisted_31 = {
  key: 3,
  class: "small text-warning-emphasis"
}
const _hoisted_32 = { class: "small" }
const _hoisted_33 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = ["type", "name", "id", "disabled", "checked", "onChange"]
const _hoisted_36 = ["for"]
const _hoisted_37 = {
  key: 0,
  class: "small text-muted mt-1"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "badge rounded-pill text-bg-primary flex-shrink-0"
}
const _hoisted_43 = {
  key: 0,
  class: "list-group"
}
const _hoisted_44 = { class: "found-values-label flex-shrink-0 fw-semibold" }
const _hoisted_45 = { class: "flex-grow-1 min-width-0" }
const _hoisted_46 = {
  key: 0,
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2 align-middle",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FoundValueOrigins = _resolveComponent("FoundValueOrigins")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    ref: "dialog",
    size: "xl"
  }, {
    title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
      _createTextVNode("Převzetí hodnot z podkladů", -1)
    ]))]),
    body: _withCtx(() => [
      (_ctx.saved !== null)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fas fa-check-circle me-2" }, null, -1)),
              _createTextVNode(" Uloženo " + _toDisplayString(_ctx.saved.count) + " " + _toDisplayString(_ctx.plural(_ctx.saved.count, 'hodnota', 'hodnoty', 'hodnot')) + ", převzatá pole ověřte ve formuláři. ", 1)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("h6", { class: "text-muted text-uppercase small fw-semibold mb-2" }, "Zbývá vyplnit", -1)),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saved.missing, (group) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: group.path,
                  class: "list-group-item d-flex gap-3 align-items-center"
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(group.label), 1),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(group.names.map(_ctx.parameterName).join(', ')), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-primary flex-shrink-0",
                    onClick: ($event: any) => (_ctx.showSegment(group.path))
                  }, " Přejít ", 8, _hoisted_6)
                ]))
              }), 128))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "small text-muted" }, " Zaškrtněte, co chcete uložit do formuláře. Co nezaškrtnete, zůstane tu na později. ", -1)),
              (_ctx.sourceOptions.length > 1)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    class: "form-select form-select-sm w-auto",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sourceId) = $event))
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("option", { value: null }, "Všechny podklady", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceOptions, (source) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: source.id,
                        value: source.id
                      }, _toDisplayString(source.name), 9, _hoisted_8))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _ctx.sourceId]
                  ])
                : _createCommentVNode("", true)
            ]),
            (_ctx.errorMessage !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            (_ctx.found.rows.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " V podkladech není nic, co by se lišilo od formuláře. "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: group.label
              }, [
                _createElementVNode("h6", _hoisted_11, _toDisplayString(group.label), 1),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.rows, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: row.name,
                      class: "list-group-item d-flex gap-3 align-items-start"
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.parameterName(row.name)), 1),
                        _createElementVNode("div", _hoisted_15, " teď: " + _toDisplayString(row.current === null || row.current === undefined ? 'nevyplněno' : _ctx.formatValue(row.name, row.current)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        (row.kind === 'multi')
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(row.items, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "form-check"
                              }, [
                                _createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: _ctx.inputId(row, index),
                                  checked: _ctx.isItemSelected(row, item.item),
                                  onChange: ($event: any) => (_ctx.toggleItem(row, item.item))
                                }, null, 40, _hoisted_17),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: _ctx.inputId(row, index)
                                }, " + " + _toDisplayString(_ctx.formatItem(row.name, item.item)), 9, _hoisted_18),
                                _createVNode(_component_FoundValueOrigins, {
                                  origins: item.origins,
                                  "source-names": _ctx.sourceNames
                                }, null, 8, ["origins", "source-names"])
                              ]))
                            }), 128))
                          : (row.kind === 'parts')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.parts, (part) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: part.key,
                                    class: "border rounded px-3 py-2 mb-2"
                                  }, [
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-link p-0 text-body text-decoration-none",
                                        "aria-expanded": _ctx.isPartExpanded(part.key),
                                        onClick: ($event: any) => (_ctx.togglePartExpanded(part.key))
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["fas fa-fw me-2", _ctx.isPartExpanded(part.key) ? 'fa-chevron-down' : 'fa-chevron-right'])
                                        }, null, 2),
                                        _createTextVNode(_toDisplayString(part.name), 1)
                                      ], 8, _hoisted_20),
                                      _createElementVNode("span", _hoisted_21, _toDisplayString(part.rooms.length) + " " + _toDisplayString(_ctx.plural(part.rooms.length, 'místnost', 'místnosti', 'místností')) + ", " + _toDisplayString(_ctx.formatNumber(part.area)) + " m² ", 1),
                                      (_ctx.statedAreaCheck(part) !== null)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: _normalizeClass(["small", _ctx.statedAreaCheck(part)!.matches ? 'text-success' : 'text-warning-emphasis'])
                                          }, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["fas me-2", _ctx.statedAreaCheck(part)!.matches ? 'fa-check' : 'fa-exclamation-triangle'])
                                            }, null, 2),
                                            _createTextVNode(_toDisplayString(_ctx.statedAreaCheck(part)!.matches
                                                        ? 'souhlasí s výkresem'
                                                        : `na výkrese ${_ctx.formatNumber(part.statedArea!)} m², rozdíl ${_ctx.formatSignedNumber(_ctx.statedAreaCheck(part)!.difference)} m²`), 1)
                                          ], 2))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("select", {
                                        class: "form-select form-select-sm w-auto ms-auto",
                                        "aria-label": "Kam část patří",
                                        value: _ctx.partChoice(row, part).target,
                                        onChange: ($event: any) => (_ctx.setPartTarget(row, part, $event))
                                      }, [
                                        _cache[8] || (_cache[8] = _createElementVNode("option", { value: "new" }, "Nová část", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentPartNames(row), (name, index) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                            _createElementVNode("option", {
                                              value: 'add:' + index
                                            }, "Přidat do „" + _toDisplayString(name) + "“", 9, _hoisted_23),
                                            _createElementVNode("option", {
                                              value: 'replace:' + index
                                            }, "Nahradit „" + _toDisplayString(name) + "“", 9, _hoisted_24)
                                          ], 64))
                                        }), 128)),
                                        _cache[9] || (_cache[9] = _createElementVNode("option", { value: "skip" }, "Nepřebírat", -1))
                                      ], 40, _hoisted_22)
                                    ]),
                                    (_ctx.partChoice(row, part).target === 'new')
                                      ? (_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          type: "text",
                                          class: "form-control form-control-sm mt-2",
                                          "aria-label": "Název nové části",
                                          value: _ctx.partChoice(row, part).name,
                                          onInput: ($event: any) => (_ctx.setPartName(row, part, $event))
                                        }, null, 40, _hoisted_25))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_FoundValueOrigins, {
                                      origins: part.origins,
                                      "source-names": _ctx.sourceNames
                                    }, null, 8, ["origins", "source-names"]),
                                    (part.inForm)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Tato část už ve formuláři je."))
                                      : _createCommentVNode("", true),
                                    (_ctx.isPartExpanded(part.key))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(part.rooms, (found, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: index,
                                              class: "form-check"
                                            }, [
                                              _createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                id: _ctx.roomInputId(part.key, index),
                                                checked: _ctx.partChoice(row, part).rooms[index],
                                                disabled: _ctx.partChoice(row, part).target === 'skip',
                                                onChange: ($event: any) => (_ctx.togglePartRoom(row, part, index))
                                              }, null, 40, _hoisted_28),
                                              _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: _ctx.roomInputId(part.key, index)
                                              }, [
                                                (found.label !== null)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createTextVNode(_toDisplayString(found.label) + ", ", 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true),
                                                _createTextVNode(_toDisplayString(_ctx.roomLabel(found.room.type)) + ", " + _toDisplayString(_ctx.formatNumber(found.area)) + " m²", 1),
                                                (found.duplicate !== null)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, ", " + _toDisplayString(found.duplicate === 'form' ? 'pravděpodobně už ve formuláři' : 'pravděpodobně stejná jako v jiném podkladu'), 1))
                                                  : _createCommentVNode("", true)
                                              ], 8, _hoisted_29)
                                            ]))
                                          }), 128))
                                        ]))
                                      : (_ctx.duplicateCount(part) > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Pravděpodobně zdvojené místnosti (" + _toDisplayString(_ctx.duplicateCount(part)) + ") nejsou vybrané. ", 1))
                                        : _createCommentVNode("", true)
                                  ]))
                                }), 128)),
                                _createElementVNode("div", _hoisted_32, [
                                  (_ctx.composedParts(row) !== null)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _cache[10] || (_cache[10] = _createTextVNode(" Výsledek ve formuláři: ", -1)),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.composedSummary(row)), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_33, "Není vybraná žádná část.")),
                                  _createElementVNode("div", _hoisted_34, [
                                    _cache[11] || (_cache[11] = _createTextVNode(" Nové části stejného názvu se spojí.", -1)),
                                    (_ctx.hasSumOnly(row))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" Plocha zadaná součtem se nahradí.")
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.options, (option, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "form-check"
                                  }, [
                                    _createElementVNode("input", {
                                      class: "form-check-input",
                                      type: row.conflict ? 'radio' : 'checkbox',
                                      name: 'found-value-' + row.name,
                                      id: _ctx.inputId(row, index),
                                      disabled: !option.valid,
                                      checked: _ctx.isOptionSelected(row, option.value),
                                      onChange: ($event: any) => (_ctx.toggleOption(row, option.value))
                                    }, null, 40, _hoisted_35),
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["form-check-label", {'text-muted': !option.valid}]),
                                      for: _ctx.inputId(row, index)
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatValue(row.name, option.value)), 1),
                                      (_ctx.optionNote(row, option) !== null)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: _normalizeClass(["small", option.valid && !option.equalsCurrent ? 'text-warning-emphasis' : 'text-muted'])
                                          }, ", " + _toDisplayString(_ctx.optionNote(row, option)), 3))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_36),
                                    _createVNode(_component_FoundValueOrigins, {
                                      origins: option.origins,
                                      "source-names": _ctx.sourceNames
                                    }, null, 8, ["origins", "source-names"])
                                  ]))
                                }), 128)),
                                (row.conflict)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _cache[12] || (_cache[12] = _createTextVNode(" Podklady se liší, vyberte správnou hodnotu. ", -1)),
                                      (_ctx.isOptionSelected(row, undefined) === false)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "btn btn-link btn-sm p-0 align-baseline",
                                            onClick: ($event: any) => (_ctx.clearSelection(row))
                                          }, " Nepřebírat ", 8, _hoisted_38))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.edits[row.name] !== undefined)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "small text-muted mb-1" }, "Uloží se upravená hodnota:", -1)),
                                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.resolveControl(_ctx.definitionOf(row.name).type)), _mergeProps({ ref_for: true }, _ctx.definitionOf(row.name), {
                                        "parameter-id": row.name,
                                        value: _ctx.edits[row.name].initial,
                                        label: _ctx.parameterName(row.name),
                                        validate: !_ctx.edits[row.name].valid,
                                        onInput: ($event: any) => (_ctx.editInput(row, $event)),
                                        onValidated: ($event: any) => (_ctx.editValidated(row, $event))
                                      }), null, 16, ["parameter-id", "value", "label", "validate", "onInput", "onValidated"])),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-link btn-sm p-0 mt-1",
                                        onClick: ($event: any) => (_ctx.cancelEdit(row))
                                      }, " Zrušit úpravu ", 8, _hoisted_40)
                                    ]))
                                  : (row.options.some(option => option.valid))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        type: "button",
                                        class: "btn btn-link btn-sm p-0 mt-1",
                                        onClick: ($event: any) => (_ctx.startEdit(row))
                                      }, " Upravit hodnotu ", 8, _hoisted_41))
                                    : _createCommentVNode("", true)
                              ], 64))
                      ]),
                      (row.isNew)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, "nové"))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ], 64))
            }), 128)),
            (_ctx.found.same.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-link btn-sm px-0 mt-3",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sameShown = !_ctx.sameShown))
                  }, [
                    _createTextVNode(" Shodné s formulářem (" + _toDisplayString(_ctx.found.same.length) + ") ", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["fas ms-2", _ctx.sameShown ? 'fa-chevron-up' : 'fa-chevron-down'])
                    }, null, 2)
                  ]),
                  (_ctx.sameShown)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.found.same, (row) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: row.name,
                            class: "list-group-item d-flex gap-3 align-items-start"
                          }, [
                            _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.parameterName(row.name)), 1),
                            _createElementVNode("div", _hoisted_45, [
                              _createTextVNode(_toDisplayString(_ctx.formatValue(row.name, row.current)) + " ", 1),
                              _createVNode(_component_FoundValueOrigins, {
                                origins: row.origins,
                                "source-names": _ctx.sourceNames
                              }, null, 8, ["origins", "source-names"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    buttons: _withCtx(() => [
      (_ctx.saved !== null)
        ? (_openBlock(), _createElementBlock("button", _hoisted_46, "Zavřít"))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              "data-bs-dismiss": "modal",
              disabled: _ctx.saving
            }, "Zavřít", 8, _hoisted_47),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: _ctx.saving || _ctx.selectedCount === 0,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, [
              (_ctx.saving)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49))
                : _createCommentVNode("", true),
              _createTextVNode(" Uložit vybrané (" + _toDisplayString(_ctx.selectedCount) + ") ", 1)
            ], 8, _hoisted_48)
          ], 64))
    ]),
    _: 1
  }, 512))
}